'use client'

import Button, { buttonClassNames } from '@components/primitives/Button'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'

interface CallToActionProps {
  buttonClassName?: string
  enrollmentCount?: number
  gradient?: boolean
  slug?: string
}

export function CallToAction({
  buttonClassName,
  enrollmentCount,
  gradient,
  slug,
}: CallToActionProps) {
  if (!enrollmentCount || !slug) {
    return null
  }

  return (
    <>
      <p className='pb-2 text-center text-xs font-semibold leading-normal text-neutral500 antialiased'>
        {enrollmentCount} Participants Needed
      </p>
      <Button
        className={classMerge(
          gradient
            ? buttonClassNames.primary.gradient
            : buttonClassNames.legacy.fill.primary,
          'h-[52px] w-full min-w-[191px] rounded-xl',
          buttonClassName,
        )}
        onClick={() => {
          trackEvent(TrackingEvents.SEARCH_LANDER_LEARN_MORE_CLICKED, {
            val: slug,
          })
          if (typeof window !== 'undefined') {
            window.open(absoluteUrl(DynamicRoutes.trial(slug)), '_blank')
          }
        }}
      >
        <Text className='text-white' styleName='p-small'>
          Learn More
        </Text>
      </Button>
    </>
  )
}
